import Tingkatan from "../../../../../components/categories/siakad/lms/data_tingkatan/Home";
export default function Home() {
  
  return (
    <Tingkatan />
  );
}
